import { Link } from "react-router-dom";
import { CONTACT, PublicPage, Section, UPDATED } from "../../components/PublicLayout";
import { CodesTable, FullGuideLink } from "../../components/CodesTable";

export default function PublicHelp() {
  return (
    <PublicPage testId="public-help-page" eyebrow="Crew help" title="GamedayTime Help" updated={UPDATED}>
      <p className="text-sm leading-relaxed text-zinc-300" data-testid="help-operator-line">GamedayTime is a DBA of CampbellsLife LLC.</p>
      <FullGuideLink testId="help-top-full-guide-link" />
      <Section title="Registering">
        <p>Registration is by invitation only. Your administrator sends an invitation email; open its link, enter your details, check the SMS consent box and verify your phone with the code we text you.</p>
      </Section>
      <Section title="Texting commands">
        <CodesTable testId="help-commands" />
      </Section>
      <Section title="The punch link and the one-time location check">
        <p>After you text IN or OUT, we reply with a link. Open it and tap the button to share your location once. We check that you are at the venue, then record your punch. We never track you continuously.</p>
      </Section>
      <Section title="Turn location permission back on">
        <p><strong>iPhone (Safari):</strong> Settings → Privacy & Security → Location Services → turn on, then Safari Websites → "While Using the App". In Safari, tap "aA" → Website Settings → Location → Allow.</p>
        <p><strong>Android (Chrome):</strong> in Chrome tap the lock icon next to the address → Permissions → Location → Allow. Also make sure phone Location is on in Settings.</p>
      </Section>
      <Section title="Stadium and indoor accuracy tips">
        <p>Step near a window or entrance, turn on Wi-Fi (it improves accuracy), wait a few seconds for the location to settle, and try again.</p>
      </Section>
      <Section title="If something fails">
        <p>Your text time is saved even if the location check fails. Request a correction and an administrator will review it.</p>
      </Section>
      <Section title="Requesting corrections">
        <p>Sign in at <Link to="/login" className="text-signal">Welcome Crew</Link> → My Clock or My Timesheets → request a correction, or use the correction link we text you.</p>
      </Section>
      <Section title="Opting out">
        <p>Reply STOP at any time. Reply START to opt back in. See the <Link to="/sms" className="text-signal">SMS Guide</Link> page.</p>
        <p data-testid="help-help-reply-note">Text HELP (or INFO) any time: we reply with a link to the full <Link to="/text" className="text-signal">Text Guide</Link> (https://gamedaytime.com/text) and our contact email.</p>
      </Section>
      <Section title="Contact">
        <p><a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a></p>
      </Section>
    </PublicPage>
  );
}
